import React, { useEffect } from "react";

import environments from "@common/environments";
import { RoutePaths as MainPaths } from "@main/router/config/routePaths";
import { AppContextProvider } from "@public/context/App/App.context";
import { AppSelectionContextProvider } from "@public/context/App/AppSelectionContext";
import useUserFeedbackDetailsApiConsumer from "@public/pages/UserFeedback/consumers/useUserFeedbackDetailsApiConsumer";
import { Navigate, useParams } from "react-router-dom";

import { UserFeedbackPage } from "../../pages/UserFeedback/UserFeedback";
import { PageNavigation } from "../components/PageNavigation";
import { Layouts } from "../Layouts";
import * as Styled from "./MainLayoutView.styles";

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export default function MainLayoutView() {
  const { issueId } = useParams();
  const isValidUuid = UUID_REGEX.test(issueId || "");
  const consumer = useUserFeedbackDetailsApiConsumer({ issueId: issueId });
  const [expiresIn, setExpiresIn] = React.useState<number | undefined>(undefined);

  useEffect(() => {
    const calculateExpiration = () => {
      const publicKeyUpdated = consumer.userFeedbackDetails?.public_key_updated;
      if (!publicKeyUpdated) return undefined;

      const publicKeyDate = new Date(publicKeyUpdated);
      if (Number.isNaN(publicKeyDate.getTime())) return undefined;

      const currentDate = new Date();
      const elapsedDays = Math.floor((currentDate.getTime() - publicKeyDate.getTime()) / (1000 * 60 * 60 * 24));
      return 30 - elapsedDays;
    };
    setExpiresIn(calculateExpiration());
  }, [consumer.userFeedbackDetails?.public_key_updated]);

  if (!isValidUuid)
    return (
      <Navigate
        to="/not-found"
        replace
      />
    );

  const openUrl = () => {
    window.open(`${environments.appURL}${MainPaths.SIGNUP}`, "_blank")?.focus();
  };

  const overlayText = (
    <>
      {expiresIn !== undefined && expiresIn > 0 && `Temporary ticket available via link for ${expiresIn} more days. `}
      <a onClick={openUrl}>{"Sign up completely free →"}</a>
      {" to save future tickets, connect integrations, and more."}
    </>
  );

  return (
    <AppContextProvider>
      <AppSelectionContextProvider>
        <Styled.Container>
          <Layouts />
          <Styled.InnerContainer>
            <PageNavigation overlayText={overlayText} />
            <UserFeedbackPage />
          </Styled.InnerContainer>
        </Styled.Container>
      </AppSelectionContextProvider>
    </AppContextProvider>
  );
}
